import React from "react";
import { dabba_images_array } from "../../content_option";
import "./style.css"; // Ensure styles are imported if needed

const Dabba = ({ openModal }) => {
  return (
    <>
      <div className="po_section">
        <h2 style={{ fontWeight: "bold", fontSize: "24px" }}>
          DABBA CONTROLLER
          <h5 style={{ fontWeight: "bold", fontSize: "10px" }}>2025</h5>
          <h6 style={{ fontWeight: "bold", fontSize: "10px" }}>
            Materials: found paint tin, foot stomp switch, led, ultrasonic sensor.
          </h6>
        </h2>

        {dabba_images_array.map((image, index) => (
          <div
            className="po_item_big"
            style={{ maxWidth: "550px", margin: "0 auto" }}
            key={index}
          >
            <img
              src={image}
              alt={`dabba-synth-${index}`}
              className="responsive-image"
              onClick={() => openModal(image)}
            />
          </div>
        ))}
      </div>
    </>
  );
};

export default Dabba;
